/* eslint-disable */
// @ts-nocheck
import React, { useContext, useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Tag } from "@carbon/react";
import ESOganisationDropdown from "../components/dropdown/esOrganisationDropdown";
import SectionHeader from "../components/section/SectionHeader";
import {
  LMR_USERS_FILTER_COLUMNS,
  LMR_USERS_TABLE_HEADERS,
  EDIT_LMR_USERS_FORM_FIELDS,
  ADD_LMR_USERS_FORM_FIELDS,
} from "../constants";
import AuthContext from "../store/authContext";
import {
  createSearchConfig,
  errorAlert,
  makeApiRequest,
  successAlert,
  transformLMRUsersResponseRow,
  transformLMRUsersRows,
  transformLMRUsersUpdateBody,
} from "../util";
import DataTableWithControls from "../components/dataTable/DataTableWithControls";
import OrgContext from "../store/orgContext";
import InfoAlert from "../ui/InfoAlert";
import TableActionButton from "../ui/TableActionButton";
import AdvancedSearch from "../components/advancedSearch/AdvancedSearch";
import { deleteLMRUser, getLMRUserByRef, updateLMRUserByRef } from "../api";
import EditRow from "../components/dataTable/EditRow";
import { INITIAL_LMR_USERS_EDIT_STATE } from "../constants/editState";
import useHideSidePanel from "../hooks/useHideSidePanel";
import {
  DELETE_LMR_USER_TRANSLATIONS,
  READ_LMR_USER_TRANSLATIONS,
} from "../translations/util";
import useAppTitle from "../hooks/useAppTitle";
import { LMRUsersEdit } from "../api/icCheck";
import SearchContext from "../store/searchContext";
import BulkUpload from "../components/bulkUpload/BulkUpload";

interface ISearchData {
  "LMR-ID"?: string | null;
  "LMR-NW-TYPE"?: string | null;
  "MAPPED-MCPTT-ID"?: string | null;
  "DISPLAY-NAME"?: string | null;
  "MUTUAL-AID"?: string | null;
}

const INITIAL_STATE = {
  "LMR-ID": "",
  "LMR-NW-TYPE": "",
  "MAPPED-MCPTT-ID": "",
  "DISPLAY-NAME": "",
  "MUTUAL-AID": "",
};

const searchFields = [
  "LMR-ID",
  "LMR-NW-TYPE",
  "MAPPED-MCPTT-ID",
  "DISPLAY-NAME",
  "MUTUAL-AID",
];

const searchConfigNew = createSearchConfig(
  searchFields,
  ADD_LMR_USERS_FORM_FIELDS,
);

const LMRUsers = () => {
  const {
    token,
    scopes: { lmr_users: lmrUsers },
  } = useContext(AuthContext);
  const { orgs: orgList, selectedOrg, updateOrg } = useContext(OrgContext);
  const { selectedColumn, setSelectedColumn, setSearchText, setDisableSearch } =
    useContext(SearchContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isPaginated, setIsPaginated] = useState(false);
  useAppTitle("LMR Users- IWF Config Admin Tool (ICAT) by AT&T");
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [usersData, setUsersData] = useState<any[]>([]);

  //Ref - to hold mutual aid user data
  const mutualAidUserRef = useRef([]);

  // State to check if Bulk Upload is Clicked
  const [isBulkUploadEnabled, setIsBulkUploadEnabled] = useState(false);

  const {
    showSidePanel,
    showAdvancedSearch,
    handleToggleAdvanceSearchPanel,
    handleToggleSidePanel,
  } = useHideSidePanel();
  const [selectedConnectionId, setSelectedConnectionId] = useState<
    string | null
  >(null);

  const [searchData, setSearchData] = useState<ISearchData>(INITIAL_STATE);
  const [numberOfRows, setNumberOfRows] = useState(0);
  const [numberOfPages, setNumberOfPages] = useState(0);
  const [flagged, setFlagged] = useState(false);
  const [searchQuery, setSearhQuery] = useState<{
    data: ISearchData;
    pageNum: number;
    pageSize: number;
    sortByField?: string;
    sortDirection?: "desc" | "asc";
  }>({
    pageSize: 20,
    pageNum: 1,
    data: {},
    sortByField: undefined,
    sortDirection: undefined,
  });

  const fetchLMRUsers = async () => {
    setLoading(true);
    try {
      if (selectedOrg) {
        const { data, pageNum, pageSize, sortByField, sortDirection } =
          searchQuery;
        // to fetch the data which has Mutual-Aid set to true
        const mutualAidQueryParams = new URLSearchParams({
          ...{
            "MUTUAL-AID": "1",
          },
        });
        // search params for LMR User data
        const queryParams = new URLSearchParams({
          page: `${pageNum}`,
          pageSize: `${pageSize}`,
          ...(sortByField && { sortByField }),
          ...(sortDirection && { sortDirection }),
          ...(data &&
            data["LMR-ID"] && {
              "LMR-ID": data["LMR-ID"],
            }),
          ...(data &&
            data["LMR-NW-TYPE"] && {
              "LMR-NW-TYPE": data["LMR-NW-TYPE"],
            }),
          ...(data &&
            data["MAPPED-MCPTT-ID"] && {
              "MAPPED-MCPTT-ID": data["MAPPED-MCPTT-ID"],
            }),
          ...(data &&
            data["DISPLAY-NAME"] && {
              "DISPLAY-NAME": data["DISPLAY-NAME"],
            }),
          ...(data &&
            ["true", "false"].includes(data["MUTUAL-AID"]?.toLowerCase()) && {
              "MUTUAL-AID":
                data["MUTUAL-AID"]?.toLowerCase() === "true" ? "1" : "0",
            }),
        });

        // Search 1: this API is called to fetch Mutual-AId data (if it exists)
        const result = await makeApiRequest<{
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          Rows: Array<any>;
        }>({
          path: `/api/v1/lmr-users?${mutualAidQueryParams}`,
          token,
          org: selectedOrg.id,
        });
        mutualAidUserRef.current = result.Rows;
        // Search 2: this API is called to fetch lmr user data
        const response = await makeApiRequest<{
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          Rows: Array<any>;
          NbrOfRows: number;
          NbrOfPages: number;
          Page: number;
        }>({
          path: `/api/v1/lmr-users?${queryParams}`,
          token,
          org: selectedOrg.id,
        });
        setNumberOfRows(response.NbrOfRows);
        setNumberOfPages(response.NbrOfPages);

        let filteredData = [];
        /**
         * flag to decide if data should be filtered -- in case search is applied then we do not
         *  need to append mutual-aid record into the final result.
         */
        const shouldFilterData =
          !data["MUTUAL-AID"] &&
          !data["LMR-ID"] &&
          !data["DISPLAY-NAME"] &&
          !data["LMR-NW-TYPE"] &&
          !data["MAPPED-MCPTT-ID"];
        // removing duplicate data(filtering out mutual-aid data)
        filteredData =
          mutualAidUserRef.current[0] && shouldFilterData
            ? response.Rows.filter(
                (row) =>
                  row["LMR-ID"] !== mutualAidUserRef.current[0]?.["LMR-ID"],
              )
            : response.Rows;

        if (pageNum === 1 && mutualAidUserRef.current[0] && shouldFilterData) {
          // to show mutual-aid user on top of page=1 of table
          setUsersData([...mutualAidUserRef.current, ...filteredData]);
        } else {
          setUsersData([...filteredData]);
        }
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e: any) {
      errorAlert(e);
    } finally {
      setLoading(false);
      setIsPaginated(false);
    }
  };

  useEffect(() => {
    setSelectedColumn(null);
    setSearchText("");
    setDisableSearch(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setSearchData(INITIAL_STATE);
    setSearhQuery({
      pageSize: 20,
      pageNum: 1,
      data: {},
      sortByField: undefined,
      sortDirection: undefined,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrg]);

  useEffect(() => {
    fetchLMRUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrg, searchQuery]);

  useEffect(() => {
    if (!showAdvancedSearch && Object.keys(searchQuery.data).length === 0) {
      setSearchData(INITIAL_STATE);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showAdvancedSearch]);

  const sortTable = (col: string, direction: "asc" | "desc") => () => {
    setSearhQuery({
      ...searchQuery,
      sortByField: col,
      sortDirection: direction,
    });
  };

  const deleteConnection = async (ref: string) => {
    if (selectedOrg && token) {
      try {
        await deleteLMRUser({
          token,
          org: selectedOrg.id,
          ref,
        });
        successAlert(DELETE_LMR_USER_TRANSLATIONS.successAlertMessage);
        handleToggleSidePanel();
        setSelectedConnectionId(null);
        fetchLMRUsers();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (e: any) {
        errorAlert(e);
      }
    }
  };

  return (
    <>
      <SectionHeader
        pageTitle={READ_LMR_USER_TRANSLATIONS.header}
        pageDescription={READ_LMR_USER_TRANSLATIONS.headerSubtext}
        sideComponent={
          <div className="dropdown-details">
            <ESOganisationDropdown
              org={selectedOrg || undefined}
              orgsList={orgList}
              setOrg={updateOrg}
            />
          </div>
        }
      />

      {selectedOrg ? (
        <>
          {showAdvancedSearch ? (
            <AdvancedSearch
              setShowAdvancedSearch={handleToggleAdvanceSearchPanel}
              advancedSearchState={searchData}
              advancedSearchConfig={searchConfigNew}
              setAdvancedSearchState={setSearchData}
              onSubmit={(data) =>
                setSearhQuery({
                  ...searchQuery,
                  pageNum: 1,
                  pageSize: 20,
                  data,
                })
              }
              onCancel={() => {
                setSearchData(INITIAL_STATE);
                handleToggleAdvanceSearchPanel();
              }}
            />
          ) : null}

          {showSidePanel && isBulkUploadEnabled ? (
            <BulkUpload
              moduleName="LMR User"
              pathName="/api/v1/lmr-users"
              csvTemplateFile={[
                "LMR-ID,LMR-NW-TYPE,MAPPED-MCPTT-ID,DISPLAY-NAME,MUTUAL-AID",
              ]}
              closeBulkUploadSidePanel={() => {
                handleToggleSidePanel();
                setIsBulkUploadEnabled(false);
                fetchLMRUsers();
              }}
            />
          ) : null}

          {showSidePanel &&
          selectedOrg &&
          selectedConnectionId &&
          !isBulkUploadEnabled ? (
            <EditRow
              panelName={READ_LMR_USER_TRANSLATIONS.editRow.panelName}
              initialState={INITIAL_LMR_USERS_EDIT_STATE}
              org={selectedOrg.id}
              esRef={selectedConnectionId}
              setShowEditPanel={handleToggleSidePanel}
              onDelete={() => deleteConnection(selectedConnectionId)}
              formFields={EDIT_LMR_USERS_FORM_FIELDS}
              header={READ_LMR_USER_TRANSLATIONS.editRow.panelName}
              showSmallSidepanel
              transformResponseRow={transformLMRUsersResponseRow}
              transformUpdateBody={transformLMRUsersUpdateBody}
              onUpdate={updateLMRUserByRef}
              loadDataByRef={getLMRUserByRef}
              hasDeletePermission={lmrUsers && lmrUsers.includes("d")}
              hasEditPermission={lmrUsers && lmrUsers.includes("u")}
              refreshTable={fetchLMRUsers}
              deleteModalItemName="LMR-ID"
              ICCheckAPI={LMRUsersEdit}
              flagged={flagged}
              setFlagged={setFlagged}
            />
          ) : null}

          <DataTableWithControls
            loading={loading}
            filterColumns={LMR_USERS_FILTER_COLUMNS}
            selectedColumn={selectedColumn}
            setSelectedColumn={setSelectedColumn}
            onSearch={(term) =>
              setSearhQuery({
                ...searchQuery,
                pageNum: 1,
                pageSize: 20,
                data: { [`${selectedColumn?.id}`]: term },
              })
            }
            setShowAdvancedSearch={handleToggleAdvanceSearchPanel}
            showCreateButton={lmrUsers && lmrUsers.includes("c")}
            onCreateButtonClick={() => {
              navigate(`/configurationManagement/lmrUsers/new`);
            }}
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            rows={transformLMRUsersRows(usersData).map((row: any) => ({
              ...row,
              "LMR-ID": row["MUTUAL-AID"] ? (
                <div className="flex items-center gap-4 ">
                  {row["LMR-ID"]}
                  <Tag
                    tag="Mutual-Aid"
                    type="default"
                    size="default"
                    filter={false}
                    disabled={false}
                    className="active-channel"
                    data-cy="lmr-user-mutual-aid"
                  >
                    <span className="mutual-aid-pill">Mutual-Aid</span>
                  </Tag>
                </div>
              ) : (
                row["LMR-ID"]
              ),
              action: (
                <TableActionButton
                  onActionButtonClick={() => {
                    setSelectedConnectionId(row.id);
                    handleToggleSidePanel();
                  }}
                />
              ),
            }))}
            numberOfAdvancedSearchFilters={searchConfigNew.reduce(
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              (acc, el: any) => {
                const { name } = el;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const obj: any = { ...searchData };
                return acc + (obj[name] && obj[name].length > 0 ? 1 : 0);
              },
              0,
            )}
            clearAdvancedSearchFilters={() => {
              setSearchData(INITIAL_STATE);
              setSearhQuery({
                ...searchQuery,
                pageNum: 1,
                pageSize: 20,
                data: {},
              });
            }}
            headers={LMR_USERS_TABLE_HEADERS}
            pageNum={searchQuery.pageNum}
            setPageNum={(pageNum) => {
              setIsPaginated(true);
              setSearhQuery({ ...searchQuery, pageNum });
            }}
            totalItems={numberOfRows}
            totalPages={numberOfPages}
            pageSize={searchQuery.pageSize}
            setPageSize={(pageSize) =>
              setSearhQuery({ ...searchQuery, pageSize })
            }
            sortByField={searchQuery.sortByField}
            sortDirection={searchQuery.sortDirection}
            handleSort={sortTable}
            showBulkUploadButton={lmrUsers && lmrUsers.includes("c")}
            onBulkUploadButtonClick={() => {
              handleToggleSidePanel();
              setIsBulkUploadEnabled(true);
            }}
          />
        </>
      ) : (
        <InfoAlert
          heading={READ_LMR_USER_TRANSLATIONS.infoAlert.heading}
          subText={READ_LMR_USER_TRANSLATIONS.infoAlert.subText}
        />
      )}
    </>
  );
};

export default LMRUsers;
